import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { ApiGatewayUrl } from "../../src/appsettings";
import ErrorException from "src/components/ErrorException";
import Rest from "../../src/core/rest";

export const createSession = createAsyncThunk(
    "userSession/createSession",
    async () => {
        try {
            const response = await Rest.post(ApiGatewayUrl + "/session");
            return response.data;
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
);
export const deleteSession = createAsyncThunk(
    "userSession/deleteSession",
    async () => {
        try {
            await Rest.delete(ApiGatewayUrl + "/session")
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
);
export const generateJWTToken = createAsyncThunk(
    "userSession/generateToken",
    async () => {
        try {
            const response = await Rest.post(ApiGatewayUrl + "/connectchannelhub");
            return response.data;
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
);

export const userSessionSlice = createSlice({
    name: "userSession",
    initialState: {
        open: false,
        msgType: null,
        JWTtoken : null
    },
    reducers: {
        openDialog(state, action) {
            return { ...state, 
                open: action.payload.open, 
                msgType: action.payload.msgType
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(generateJWTToken.fulfilled, (state, action) => {
                return {
                    ...state,
                    JWTtoken:action.payload
                }
            })
            .addCase(generateJWTToken.pending, (state) => {
                return { ...state, JWTtoken: null };
              })
              .addCase(generateJWTToken.rejected, (state) => {
                return { ...state, JWTtoken: null };
              })
    }
});
export const userSessionActions = userSessionSlice.actions;
export const userSessionState = (state) => state.userSession;
export default userSessionSlice.reducer;